import { SharedState } from "./SharedState";

export class UserService {
    static IsUserInRole(role) {
        let user = SharedState.getValue("loggedInUser");
        return user && user.roles && user.roles.findIndex(r => r === role) >= 0;
    }

    static IsUserInAnyRole(roles) {
        const user = SharedState.getValue("loggedInUser");
        return  user && user.roles && user.roles.findIndex(ur => roles.findIndex(r => r === ur) >= 0) >= 0;
    }
}
